/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs.js'

const $nsid = 'app.bsky.unspecced.searchActorsSkeleton'

export { $nsid }

/** Backend Actors (profile) search, returns only skeleton. */
const main = l.query(
  $nsid,
  l.params({
    q: l.string(),
    viewer: l.optional(l.string({ format: 'did' })),
    typeahead: l.optional(l.boolean()),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 25),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    hitsTotal: l.optional(l.integer()),
    actors: l.array(
      l.ref<UnspeccedDefs.SkeletonSearchActor>(
        (() => UnspeccedDefs.skeletonSearchActor) as any,
      ),
    ),
  }),
  ['BadQueryString'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
